import React from 'react';
import MuiDialogActions from '@mui/material/DialogActions';
import Dialog from 'components/Dialog';
import {Theme} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from 'components/Button';
import i18n from 'i18n';

const DialogActions = withStyles((theme: Theme) => ({
   root: {
      margin: 0,
      padding: theme.spacing(1),
   },
}))(MuiDialogActions);

export type ConfirmDialogData = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   confirmLabel?: string;
   cancelLabel?: string;
};

type Props = {
   data: ConfirmDialogData;
   onClose: (result?: boolean) => void;
};
export const ConfirmDialog = (props: Props) => {
   const {data, onClose} = props;
   const {
      open = true,
      content = i18n.t('Proceed?'),
      title = i18n.t('Confirmation'),
      confirmLabel = i18n.t('Ok'),
      cancelLabel = i18n.t('Cancel'),
   } = data;

   return (
      <Dialog header={title} open={open}>
         {content}
         <DialogActions>
            <Button onClick={() => onClose(true)} color="primary">
               {confirmLabel}
            </Button>
            <Button autoFocus onClick={() => onClose(false)} color="primary">
               {cancelLabel}
            </Button>
         </DialogActions>
      </Dialog>
   );
};
